// Calendar dates are anchored to the lending desk's India timezone.
export function buildDashboardTrend(rows, days = 7, now = new Date()) {
    const today = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit'
    }).format(now);
    const end = new Date(`${today}T00:00:00Z`);
    const byDay = new Map(rows.map(row => [String(row.day).slice(0, 10), row]));
    return Array.from({ length: days }, (_, index) => {
        const date = new Date(end);
        date.setUTCDate(date.getUTCDate() - days + 1 + index);
        const id = date.toISOString().slice(0, 10);
        const row = byDay.get(id);
        const amount = Number(row?.amount) || 0;
        const loans = Number(row?.loans ?? row?.count) || 0;
        return {
            id, fullDate: id,
            dateLabel: date.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', timeZone: 'UTC' }),
            amount, loans, avgTicket: loans ? Math.round(amount / loans) : 0
        };
    });
}
